import React from 'react';
import Radio from 'components/shared/StandaloneRadio';
import FieldRow from './FieldRow';

/**
 * Modern (Tailwind) counterpart of components/PropertyRadio.
 *
 * Same name, same props, same outward handleChange(propertyName, value) contract.
 * Everything above render() is copied verbatim — note that handleChange reports
 * valueForTrue[0] rather than the event's checked state, which is what makes these
 * behave as a mutually exclusive group driven by the parent. Only render() differs:
 * the legacy Row/Col (and the now-pointless <Form> wrapper) give way to a FieldRow
 * so the radios line up with the other property rows in the card.
 */
export default class PropertyRadio extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isChecked: this.props.valueForTrue.indexOf(this.props.property.value) !== -1
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {

        //const value = e.target.checked;
        this.props.handleChange(this.props.property.info.name, this.props.valueForTrue[0]);

        const value = this.props.valueForTrue.indexOf(this.props.property.value);

        this.setState({
            isChecked: value === -1 ? false : true
        });
    }

    render() {
        return (
            <FieldRow label={this.props.title} disabled={this.props.disabled} className={this.props.className}>
                <Radio
                    disabled={this.props.disabled}
                    style={{ padding: '0' }}
                    name={this.props.property.info.name}
                    checked={this.props.isChecked}
                    onClick={this.handleChange}
                    onChange={this.handleChange}
                />
            </FieldRow>
        );
    };
}
